export default {"src":"/_next/static/media/ConsultationsFill.a6f25ac0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};